"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _Group = _interopRequireDefault(require("./Group")),
    _Filter = _interopRequireDefault(require("./Filter")),
    _CommentPopover = _interopRequireDefault(require("../../CommentPopover"));

require("../styles/_comments-tab.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var CLOSE_MODAL_ORIGIN = "comments-tab";

function commentTextMatchesFilter(_ref, searchTerm) {
  var content = _ref.content;
  return !searchTerm || (0, _lodash["default"])(content, "blocks[0].text", "").toLowerCase().trim().includes(searchTerm.trim().toLowerCase());
}

function commentTitleMatchesFilter(comment, getTitle, searchTerm) {
  if (!getTitle) return !1;
  var title = getTitle(comment);
  return !searchTerm || title && title.toLowerCase().trim().includes(searchTerm.trim().toLowerCase());
}

var CommentsTab = function (_Component) {
  function CommentsTab(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, CommentsTab), _this = _super.call(this, props), _this.groupComments = (0, _memoizeOne["default"])(function (comments) {
      var groupCommentsFn = _this.props.groupCommentsFn;
      return groupCommentsFn ? groupCommentsFn(comments) : _this.defaultGroupFn(comments);
    }), _this.defaultGroupFn = (0, _memoizeOne["default"])(function (comments) {
      return comments.map(function (comment, index) {
        return {
          groupId: index + 1,
          title: "",
          comments: [comment]
        };
      });
    }), _this.onFilter = (0, _memoizeOne["default"])(function (_ref2) {
      var comments = _ref2.comments,
          searchTerm = _ref2.searchTerm,
          getCommentTitle = _this.props.getCommentTitle;
      return comments.filter(function (_ref3) {
        var parentId = _ref3.parentId;
        return !parentId;
      }).filter(function (comment) {
        return commentTextMatchesFilter(comment, searchTerm) || commentTitleMatchesFilter(comment, getCommentTitle, searchTerm);
      });
    }), _this.getOrderedCommentIds = (0, _memoizeOne["default"])(function (groupedComments) {
      return groupedComments.reduce(function (newArray, group) {
        return [].concat((0, _toConsumableArray2["default"])(newArray), (0, _toConsumableArray2["default"])(group.comments.map(function (comment) {
          return comment.commentId;
        })));
      }, []);
    }), _this.onPopoverOuterAction = function (event) {
      var closePopover = _this.props.closePopover,
          commentsTab = document.querySelector(".comment--comment-selected");
      return commentsTab && !commentsTab.contains(event.target) && (_this._currentCommentId = void 0), void closePopover({
        closeModalOrigin: CLOSE_MODAL_ORIGIN
      });
    }, _this.handleSelectComment = function (_ref4) {
      var commentId = _ref4.commentId,
          _this$props = _this.props,
          onSelectComment = _this$props.onSelectComment,
          showCommentModal = _this$props.showCommentModal,
          showAddCommentButton = _this$props.showAddCommentButton,
          comments = _this$props.comments,
          commentModalId = _this$props.commentModalId,
          closeModalOrigin = _this$props.closeModalOrigin,
          closePopover = _this$props.closePopover;
      if (_this._currentCommentId === commentId || !commentModalId && closeModalOrigin && closeModalOrigin !== CLOSE_MODAL_ORIGIN) return _this._currentCommentId = void 0, void closePopover({
        closeModalOrigin: CLOSE_MODAL_ORIGIN
      });
      _this._currentCommentId = commentId;
      var preferPlace = showAddCommentButton ? {
        preferPlace: "row"
      } : {};
      showCommentModal(commentId, _objectSpread({
        onOuterAction: _this.onPopoverOuterAction
      }, preferPlace)), onSelectComment && onSelectComment(commentId, comments.find(function (comment) {
        return comment.commentId === commentId;
      }));
    }, _this.defaultTitle = function (index) {
      return function () {
        return "Comment (".concat(index, ")");
      };
    }, _this.renderComments = (0, _memoizeOne["default"])(function (commentGroups) {
      var _this$props2 = _this.props,
          getCommentTitle = _this$props2.getCommentTitle,
          selectedGroupId = _this$props2.selectedGroupId,
          selectedCommentId = _this$props2.selectedCommentId;
      return _react["default"].createElement("div", {
        className: "comments-tab-container__comments-list-container__comments-list"
      }, commentGroups.map(function (group, index) {
        return _react["default"].createElement(_Group["default"], {
          key: group.groupId,
          isGroupSelected: selectedGroupId === group.groupId,
          group: group,
          getCommentTitle: getCommentTitle || _this.defaultTitle(index + 1),
          onSelectComment: _this.handleSelectComment,
          selectedCommentId: selectedCommentId,
          commentIds: _this.getOrderedCommentIds(commentGroups)
        });
      }));
    }), _this.onSearch = function (_ref5) {
      var value = _ref5.target.value;

      _this.setState({
        searchTerm: value
      });
    }, _this.handleAddComment = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var showCommentModal, newCommentId;
      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              showCommentModal = _this.props.showCommentModal, newCommentId = Date.now().toString(), _this.setState({
                newCommentId: newCommentId
              }), showCommentModal(newCommentId, {
                preferPlace: "left"
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.state = {
      searchTerm: ""
    }, _this;
  }

  (0, _inherits2["default"])(CommentsTab, _Component);

  var _super = _createSuper(CommentsTab);

  return (0, _createClass2["default"])(CommentsTab, [{
    key: "renderCommentPopover",
    value: function renderCommentPopover() {
      var newCommentId = this.state.newCommentId,
          _this$props3 = this.props,
          onAddComment = _this$props3.onAddComment,
          selectedCommentId = _this$props3.selectedCommentId,
          isNewComment = selectedCommentId === newCommentId;
      return _react["default"].createElement(_CommentPopover["default"], (0, _extends2["default"])({
        id: selectedCommentId || newCommentId
      }, isNewComment ? {} : {
        commentId: selectedCommentId
      }, {
        onAddComment: onAddComment
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])("comments-tab-container__popover", {
          "comments-tab-container__popover-new": isNewComment
        }, {
          "comments-tab-container__popover-existing": !isNewComment
        })
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var searchTerm = this.state.searchTerm,
          _this$props4 = this.props,
          comments = _this$props4.comments,
          tabTitle = _this$props4.tabTitle,
          addCommentDisabled = _this$props4.addCommentDisabled,
          isReadOnly = _this$props4.isReadOnly,
          showAddCommentButton = _this$props4.showAddCommentButton,
          filteredComments = this.onFilter({
        comments: comments,
        searchTerm: searchTerm
      }),
          commentGroups = this.groupComments(filteredComments);
      return _react["default"].createElement("div", {
        className: "comments-tab-container"
      }, _react["default"].createElement(_Filter["default"], {
        searchTerm: searchTerm,
        onSearch: this.onSearch
      }), _react["default"].createElement("p", {
        className: "comments-tab-container__heading"
      }, "".concat(tabTitle || "Comments", " (").concat(filteredComments.length, ")")), this.renderComments(commentGroups), showAddCommentButton && !isReadOnly ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_uiKit.Button, {
        className: "comments-tab-container__comments-list-container__button",
        onClick: this.handleAddComment,
        small: !0,
        disabled: addCommentDisabled
      }, "ADD COMMENT"), this.renderCommentPopover()) : null);
    }
  }]), CommentsTab;
}(_react.Component),
    _default = CommentsTab;

exports["default"] = _default;